import SearchIcon from '~/components/icons/ui/32px_zoom-2.svg'
import CloseIcon from '~/components/icons/ui/64px_small-remove.svg'
import styled from 'styled-components'

const Button = styled.button`
  display: flex;
  border-radius: 8px;
  border: none;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.primary};
  box-shadow: ${({ theme }) => theme.shadow(1)};
  height: 40px;
  width: 40px;
  background-color: white;
`

interface BaseButtonProps {
  isOpen: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}

export const BaseButton = ({ isOpen, onClick }: BaseButtonProps) => {
  return (
    <Button onClick={onClick}>
      {isOpen ? (
        <CloseIcon fill={'#0C2340'} width={20} height={20} />
      ) : (
        <SearchIcon fill={'#0C2340'} width={20} height={20} />
      )}
    </Button>
  )
}
